import { lazy } from "react";

const PublicRoutes = [
  {
    path: "/signin",
    component: lazy(() => import("../pages/auth/signIn")),
    exact: true,
  },
  {
    path: "/signup",
    component: lazy(() => import("../pages/auth/signUp")),
    exact: true,
  },
  {
    path: "/forgot-password",
    component: lazy(() => import("../pages/auth/forgotPassword")),
    exact: true,
  },
  {
    path: "/reset-password/:token",
    component: lazy(() => import("../pages/auth/resetPassword")),
    exact: true,
  },
 
 
  {
    path: "/landing",
    component: lazy(() => import("../pages/landing")),
    exact: true,
  },
  {
    path: "*",
    component: lazy(() => import("../pages/page404")),
    exact: true,
  },
];

const PrivateRoutes = [
  {
    path: "/",
    component: lazy(() => import("../pages/home")),
    exact: true,
  }, 
  {
    path: "/available-assesments/:id",
    component: lazy(() => import("../pages/available-assesments")),
    exact: true,
  },
  {
    path: "/questions-details/:id", 
    component: lazy(() => import("../pages/questions-details")),
    exact: true,
  },
  {
    path: "/profile",
    component: lazy(() => import("../pages/candinate-profile")),
    exact: true,
  },
  {
    path: "/applied-jobs",
    component: lazy(() => import("../pages/applied-jobs")),
    exact: true,
  },
  {
    path: "*",
    component: lazy(() => import("../pages/page404")),
    exact: true,
  },
];

const CommonRoutes = [
  {
    path: "/verify-account/:token",
    component: lazy(() => import("../pages/auth/verify-account")),
    exact: true, 
  },
]

export { PublicRoutes, PrivateRoutes,CommonRoutes };